import { http } from "@/lib/api";

export const DEFAULT_LOGO = "/brand/logo.png";

let cached = null;
export async function getBrandLogo() {
  if (cached) return cached;
  try {
    const r = await http.get("/public/branding");
    cached = r.data.logo_url || DEFAULT_LOGO;
  } catch {
    cached = DEFAULT_LOGO;
  }
  return cached;
}
